export const isRunningInApp = () => {
    return (
      window.IS_NATIVE_APP === true ||
      typeof window.flutter_inappwebview !== "undefined" ||
      window.Capacitor ||
      window.cordova ||
      window.ReactNativeWebView
    );
  };
  